export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6936.560275e5.jpg";